import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { SubscriptionRenewalComponent } from './rinnova-offerta';

// @ngInject
let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {

    $stateProvider
        .state('usersettings.rinnova-offerta', {
            url: '/rinnova-offerta',
            views: {
                'userContent': {
                    template: '<rinnova-offerta></rinnova-offerta>'
                }
            },
            ncyBreadcrumb: {
                label: 'Rinnova Offerta',
                parent: 'usersettings.gestione-offerta'
            },
            data: {
                authorisationLevel: 1,
                pageTitle: 'Rinnova Offerta'
            }
        }
        );
};

stateConfig.$inject = ['$stateProvider'];

export const RinnovaOffertaModule: string = ng
    .module('archiSmall.userSettings.rinnovaOffertaModule', [
        'ui.bootstrap',
        uiRouter,
        'ncy-angular-breadcrumb'
    ])
    .component('rinnovaOfferta', SubscriptionRenewalComponent)
    .config(stateConfig)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/usersettings/rinnova-offerta/rinnova-offerta.module.ts